import { Link } from 'react-router-dom';
import { useTheme } from '@/contexts/ThemeContext';

export default function Footer() {
  const { theme } = useTheme();
  
  // Check if we're on a broker page by looking at the body class
  const isBrokerTheme = document.body.classList.contains('broker-theme');
  
  // If on broker page, check the actual applied theme from document element
  const currentTheme = isBrokerTheme 
    ? (document.documentElement.classList.contains('dark') ? 'dark' : 'light')
    : theme;
  
  // Logo URL based on current theme
  const logoUrl = currentTheme === 'dark' 
    ? 'https://tvalgxmzomdvttzuyznf.supabase.co/storage/v1/object/public/public/logos/vitrinelogo-white.png'
    : 'https://tvalgxmzomdvttzuyznf.supabase.co/storage/v1/object/public/public/logos/vitrinelogo-black.png';

  return (
    <footer className="mt-auto py-4 bg-muted/30">
      <div className="container mx-auto px-4 flex flex-col items-center space-y-1">
        <img 
          src={logoUrl} 
          alt="VitrineTurbo" 
          className="h-12 w-auto"
        />
        <p className="text-sm text-muted-foreground">
          Crie sua Vitrine Digital em minutos
        </p>
      </div>
    </footer>
  );
}